import _get from 'lodash/get'

export const isPlanAvailable = plan => _get(plan, 'hasAvailableDevices', true)
export const isInventoryForChangePlanAvailable = plan => _get(plan, 'hasInventoryForChangePlan', true)
